import { useRegionReach } from "./map/useRegionReach";
import { SCOPES_MESHCORE_ONLY_NOTE } from "../lib/mapScopes";
import { REACH_CONTROL_LABEL, REACH_NONE_LABEL, reachChoices } from "../lib/regionReach";

// "Region reach": a base-map overlay that shades where one scope's packets were heard in the last 7 days. One scope
// at a time, none by default; works whatever "Colour by" is set to. The list of scopes is loaded the first time the
// picker is used. Markers keep their colouring; this only adds the soft shading (LiveMap).
export function RegionReachControl() {
  const { selected, select, available, prime, payload, pending } = useRegionReach();
  const choices = reachChoices(payload);
  return (
    <label className="region-reach" title={available ? "Shade where packets carrying one scope were heard in the last 7 days" : SCOPES_MESHCORE_ONLY_NOTE}>
      <span className="region-reach-label">{REACH_CONTROL_LABEL}</span>
      <select
        className="region-reach-select"
        aria-label={REACH_CONTROL_LABEL}
        value={available ? selected ?? "" : ""}
        disabled={!available}
        title={available ? undefined : SCOPES_MESHCORE_ONLY_NOTE}
        onFocus={prime}
        onMouseDown={prime}
        onChange={(e) => select(e.target.value === "" ? null : e.target.value)}
      >
        <option value="">{REACH_NONE_LABEL}</option>
        {selected !== null && !choices.some((c) => c.key === selected) && <option value={selected}>{selected}</option>}
        {choices.map((c) => (
          <option key={c.key} value={c.key}>
            {c.label} ({c.repeaters})
          </option>
        ))}
        {pending && <option disabled>Not calculated yet</option>}
      </select>
    </label>
  );
}
